import FlatList from "react-native-web/dist/exports/FlatList";
import listenToKeyboardEvents from "./KeyboardAwareHOC";
export default listenToKeyboardEvents(FlatList);